import "./NewsArticle.scss";

import React from "react";

import {
  Box,
  Grid2,
  Typography
} from "@mui/material";

import AsideContent from "../../shared/components/aside-content/AsideContent";
import Breadcrumb from "../../shared/components/breadcrumb/Breadcrumb";
import ContentBlock from "../../shared/components/content-block/ContentBlock";
import {
  FeatureToggle,
  NewsReleaseContent,
  PhSiteSettings
} from "../../shared/models/app-data-model";

import RelatedArticleGroup from "../../shared/components/related-article-group/RelatedArticleGroup";

export type NewsArticleProps = {
  content: NewsReleaseContent;
  featureToggles: FeatureToggle[];
  phSiteSettings: PhSiteSettings;
};


const NewsArticle: React.FC<NewsArticleProps> = (props: NewsArticleProps, featureToggles) => {
  const title = props.content.seo?.title;
  const content =
    props.content.page_content && props.content.page_content.content_block.length > 0
      ? props.content.page_content.content_block.map((item, index) => <ContentBlock contentBlock={item} key={index} featureToggles={props.featureToggles} phSiteSettings={props.phSiteSettings} />)
      : null;
  const contentHeader = props.content.page_content && props.content.page_content.content_header;
  const asideContent = props.content.aside_content && <AsideContent asideContent={props.content.aside_content} />;
  const url = props.content.url;
  const relatedArticleGroup = <RelatedArticleGroup relatedArticleGroupData={props?.content?.related_articles} categoryChooser={props?.content?.category_chooser}></RelatedArticleGroup>;

  return (
    <>
      <Grid2 container rowSpacing={2} columnSpacing={4} className='news-article' maxWidth="xl">
        <Grid2 size={{ xs: 12}} className="hero_wrapper">
          <h1 className="news-title">{title}</h1>
        </Grid2>
        
        <Grid2 size={{ xs: 12}} container className='page-info'>
          <Grid2 container className='breadcrumb'>
            <Breadcrumb url={url} featureToggles={featureToggles}></Breadcrumb>
          </Grid2>
        </Grid2>


        
          {asideContent &&  <Grid2 container size={{ xs: 12, md: 4, lg:3 }} component='aside' className="page-aside">
            {asideContent}
          </Grid2>}
          <Grid2 container size="grow" component="main" className="pageContent">
            {contentHeader && <h2 className="page-content-header">{contentHeader}</h2>}
            <div>{content}</div>
            {relatedArticleGroup}
          </Grid2>
        </Grid2>
      
    </>
  )
};

export default NewsArticle;
